// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfilingTagsFilter_container__2ksYQ","deleteIcon":"ProfilingTagsFilter_deleteIcon__2FM1w"};